import { getLoggedUser } from "../../database/indexedDbReadWrite";
import { httpGet, httpPost } from "../httpService/httpService";

export const Login = (username: string, password: string, apiUrl: string, apiVersion: string, token: string | null, guidSession: string | null) => {
    return new Promise((resolve, reject) => {
        return httpPost(apiUrl + apiVersion + "/login", {
            username: username,
            password: password,
            referer: window.location.hostname,
            token: token,
            guidSession: guidSession
        }).then((res: any) => {
            resolve(res);
        }).catch((error: any) => {
            reject(error);
        });
    })
}

export const Logout = (apiUrl: string, apiVersion: string) => {
    return getLoggedUser().then((logged) => {
        var login = sessionStorage.getItem("isActiveLoginSOPO");
        if(logged && login == null){
            login = logged.val
        }
        if (login != null) {
            return new Promise((resolve, reject) => {
                return httpPost(apiUrl + apiVersion + "/logout", {
                    login: login
                }).then((res: any) => {
                    resolve(res);
                }).catch((error: any) => {
                    reject(error);
                });
            })
        }
    })
}

export const IsActive = (apiUrl: string, apiVersion: string) => {
    var login = sessionStorage.getItem("isActiveLoginSOPO");
    var session = sessionStorage.getItem("SOPOGuidSession");
    if (login != null) {
        return new Promise((resolve, reject) => {
            return httpPost(apiUrl + apiVersion + "/isActive", {
                login: login,
                guidSession: session
            }).then((res: any) => {
                resolve(res);
            }).catch((error: any) => {
                reject(error);
            });
        })
    }
}

export const GetUserId = (apiUrl: string, apiVersion: string) => {
    return new Promise((resolve, reject) => {
        return httpGet(apiUrl + apiVersion + "/user")
            .then((res: any) => {
                resolve(res?.data);
            }).catch((error: any) => {
                reject(error);
            });
    })
}